/*
  Rating_v2.js propTypes
  extracted from https://bully---varnish.ref-sa-tech.io/documentation/resources/oaspec.json
  on 2019-04-15T15:32:06.065Z
*/

import { bool, number, string } from 'prop-types'

const Rating_v2 = {
  author: string,
  code: string,
  date: number,
  feedbackNegative: number,
  feedbackPositive: number,
  inReview: bool,
  productCode: string,
  productTitle: string,
  rating: number,
  text: string,
  thumbnailURL: string,
  title: string,
  unit: string,
  unitPricing: string,
  unitQuantityString: string,
}

export default Rating_v2
